<template>
    <data-filter v-model="query.page">
        <b-pagination
            size="md"
            slot-scope="{ set }"
            @change="set"
            :hide-goto-end-buttons="true"
            :total-rows="Number(result.total)"
            :value="query.page"
            :per-page="Number(result.perPage)"
        ></b-pagination>
    </data-filter>
</template>

<script>
export default {
    props: {
        query: {
            type: Object,
            required: true,
        },
    },
};
</script>
